"use client";

import { Play, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Riproduzione() {
  const line1 = useRevealOnScroll<HTMLSpanElement>({
    once: true,
    threshold: 0.1
  });
  const line2 = useRevealOnScroll<HTMLSpanElement>({
    once: true,
    threshold: 0.1
  });
  const line3 = useRevealOnScroll<HTMLSpanElement>({
    once: true,
    threshold: 0.1
  });
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    once: true,
    threshold: 0.1
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="930" id="fisiopatologia-della-riproduzione" className="relative w-full overflow-hidden bg-[hsl(215_25%_12%)] dark" style={{
    height: "100vh",
    minHeight: "780px"
  }}>
      {}
      <div className="absolute inset-0 z-0">
        <video className="h-full w-full object-cover" autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_precision_care.png">
          <source src="https://cdn.coverr.co/videos/coverr-medical-research-lab-4822/1080p.mp4" type="video/mp4" />
        </video>
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/20 via-black/40 to-black/70" />

      {}
      <div className="absolute inset-0 z-10 bg-[radial-gradient(ellipse_at_center,transparent_40%,hsl(215_25%_12%/0.6)_100%)]" />

      {}
      <div className="relative z-20 flex h-full w-full items-center">
        <div className="w-full px-6 md:pl-[8%] md:pr-8">
          <div className="max-w-3xl">
            {}
            <div ref={eyebrow.ref} className={`mb-8 md:mb-12 transition-all duration-1000 ease-out ${eyebrow.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <p className="font-mono text-[11px] md:text-xs tracking-[0.25em] uppercase text-white/90" style={{
              letterSpacing: "0.25em"
            }}>
                <span className="inline-block w-8 h-px bg-[hsl(350_70%_65%)] align-middle mr-3" />
                DOTT. MIRKO COLLOCA &mdash; SPECIALISTA
              </p>
            </div>

            {}
            <h1 className="font-serif font-light text-white leading-[0.95] tracking-tight" style={{
            fontSize: "clamp(2.75rem, 8vw, 6rem)"
          }}>
              <span className="block overflow-hidden">
                <span ref={line1.ref} className={`block transition-all duration-[1200ms] ease-out ${line1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"}`} style={{
                transitionDelay: "200ms"
              }}>
                  Eccellenza nella
                </span>
              </span>
              <span className="block overflow-hidden">
                <span ref={line2.ref} className={`block transition-all duration-[1200ms] ease-out ${line2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"}`} style={{
                transitionDelay: "500ms"
              }}>
                  <em className="italic font-light text-[hsl(350_70%_65%)]">Fisiopatologia</em> della
                </span>
              </span>
              <span className="block overflow-hidden">
                <span ref={line3.ref} className={`block transition-all duration-[1200ms] ease-out ${line3.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"}`} style={{
                transitionDelay: "800ms"
              }}>
                  Riproduzione Umana.
                </span>
              </span>
            </h1>

            {}
            <p ref={paragraph.ref} className={`mt-8 md:mt-10 max-w-[480px] text-base md:text-lg leading-relaxed text-white/85 font-default transition-all duration-1000 ease-out ${paragraph.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "1100ms"
          }}>
              Percorsi diagnostici e terapeutici personalizzati per la salute riproduttiva, 
              fondati su rigore scientifico e profonda dedizione al paziente.
            </p>

            {}
            <div ref={ctas.ref} className={`mt-10 md:mt-12 flex flex-col sm:flex-row gap-4 transition-all duration-1000 ease-out ${ctas.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "1300ms"
          }}>
              <Button asChild size="lg" className="h-12 px-7 bg-[hsl(350_70%_65%)] hover:bg-[hsl(350_70%_60%)] text-white font-mono text-xs tracking-[0.2em] uppercase rounded-lg shadow-lg">
                <Link to="/HumanReproductionPage">
                  Scopri i Servizi
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="h-12 px-7 bg-transparent border border-white/40 hover:bg-white/10 text-white hover:text-white font-mono text-xs tracking-[0.2em] uppercase rounded-lg backdrop-blur-sm">
                <Link to="/ContactsPage">
                  <Play className="mr-1 h-4 w-4 fill-current" />
                  Prenota Visita
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 right-6 md:right-10 z-20 hidden md:flex flex-col items-center gap-3">
        <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/70" style={{
        writingMode: "vertical-rl",
        textOrientation: "mixed"
      }}>
          SCORRI
        </span>
        <div className="relative h-12 w-px overflow-hidden">
          <div className="absolute inset-0 bg-white/20" />
          <div className="absolute top-0 left-0 w-px h-6 bg-[hsl(350_70%_65%)]" style={{
          animation: "scrollBounce 2s ease-in-out infinite"
        }} />
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-6 md:left-[8%] z-20 hidden md:flex items-end gap-3 max-w-[260px]">
        <svg className="h-12 w-12 text-[hsl(350_70%_65%)]/80 flex-shrink-0" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M32 8 C20 8 12 18 12 28 C12 32 14 34 18 34 L46 34 C50 34 52 32 52 28 C52 18 44 8 32 8 Z" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.15" />
          <path d="M28 34 L26 56 M32 34 L32 58 M36 34 L38 56" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
          <path d="M18 28 L46 28 M22 22 L42 22" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" opacity="0.6" />
        </svg>
        <div className="pb-1 border-l border-white/20 pl-3">
          <p className="font-mono text-[10px] tracking-wider uppercase text-white/60 leading-tight">
            § 01
          </p>
          <p className="font-serif italic text-sm text-white/85 leading-snug mt-1">
            Approccio Clinico
          </p>
          <p className="font-mono text-[10px] tracking-wider uppercase text-white/50 leading-tight mt-0.5">
            Precisione Medica
          </p>
        </div>
      </div>

      <style>{`
        @keyframes scrollBounce {
          0%, 100% {
            transform: translateY(-100%);
          }
          50% {
            transform: translateY(100%);
          }
        }
      `}</style>
    </section>;
}